<div *ngIf="displayMaxSavedCartErrorMsg">
  <vs-custom-global-msg ></vs-custom-global-msg>
</div>
<div class="carts-main">
<p *ngIf="dataSource && dataSource.length > 0" class="tb-parent mngText">
  {{ "savedCart.listPageInfoTitle" | cxTranslate }}
</p>
<div class="savedCarts-parent">
<mat-tab-group (selectedTabChange)="tabClick($event)" [selectedIndex]="allowedPermissionFlag">
  <mat-tab [disabled]="buyCartPermission">
    <ng-template mat-tab-label>
      <i class="material-icons">shopping_cart</i>
      {{ "savedCart.buyCart" | cxTranslate }}
    </ng-template>
      <div class="d-flex align-items-center mb-3">
        <div class="mr-auto m-top" >
        <bh-button-tabs [items]='tabsOptions'  (activeTabUpdate)="onTabClick($event)"
          small="false" menu-width="fluid" tooltip-message="Secondary Options" active-key="">
        </bh-button-tabs>
        </div>
          <div class="search-layout m-top" >
            <input type="text"
            class="form-control"
            placeholder='{{ "savedCart.searchPlaceholder" | cxTranslate }}'
            name="search"
            [(ngModel)]="searchText"
            #search
            (keyup)="keyUp(search.value, $event)"
            >
            <span><i class="material-icons search-icon" (click)="modelChange(search.value)">search</i></span>
          </div>
    
          <div class="sort-layout">
            <label>{{ "savedCart.sortBy" | cxTranslate }}</label>
            <div>
              <form [formGroup]="savedCartForm">
                <ng-select
                  formControlName="sortBy"
                  name="sortBy"
                  [(ngModel)]="sortBy"
                  (change)="loadCartData()"
                  [searchable]="false"
                  [clearable]="false"
                  placeholder='{{ "savedCart.selectPlaceholder" | cxTranslate }}'
                >
                  <ng-option *ngFor="let option of sortOptions" value="{{ option.value }}">
                    {{ option.label }}
                  </ng-option>
                </ng-select>
              </form>
            </div>
          </div>
    
        </div>
          <div class="clear-filter">
            <div class="left-content filter-txt" *ngIf="searchFilter">
              {{ "quoteTracking.search" | cxTranslate }}{{this.searchText}}
              <i class="material-icons" (click)="clearSearchFilter()">close</i>
            </div>
          </div>
    
    <div
      *ngIf="dataSource && dataSource.length > 0"
      class="saved-cart-container mb-4"
    >
    <ng-container *ngIf="!displayLoader else loading">
    <ng-container *ngIf="sharedCart == 'false'">
      <bh-tabular-list  id="my-carts-table" refresh="false" [attr.header]="getHeader()" [attr.schema]="getSchema()"
        (bhEventChange)="changes($event)" (bhEventAppended)="changes($event)" [attr.payload]="getPayload()" noDataAvailable="No data available"
        [attr.option]="getOptions()" ></bh-tabular-list>
    </ng-container>
    <ng-container *ngIf="sharedCart == 'true'">
      <bh-tabular-list  id="shared-carts-table" refresh="false" [attr.header]="getSharedHeader()" [attr.schema]="getSharedSchema()"
        (bhEventChange)="changes($event)" (bhEventAppended)="changes($event)" [attr.payload]="getSharedPayload()" noDataAvailable="No data available"
        [attr.option]="getSharedOptions()" ></bh-tabular-list>
    </ng-container>
  </ng-container>
    </div>
    
      <div *ngIf=" isSaveCartEmpty && dataSource.length == 0"  class="empty-cart-page">
        <div class="container">
          <div class="empty-img"></div>
          <h1>{{ "savedCart.noCardSaved" | cxTranslate }}</h1>
          <span>{{ "savedCart.saveCardSuggestion" | cxTranslate }}</span>
          <p>{{ "savedCart.saveExistingCart" | cxTranslate }}</p>
        </div>
      </div>
    
    
    <ng-template #loading>
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    </ng-template>
    
  </mat-tab>

  <mat-tab  [disabled]="quotePermission">
    <ng-template mat-tab-label>
      <img src="../../../../assets/icons/List_alt.svg" class="material-icons" />
      {{ "savedCart.quoteCart" | cxTranslate }}
    </ng-template>
      <div class="d-flex align-items-center mb-3">
        <div class="mr-auto m-top" >
        <bh-button-tabs [items]='cartOptions'  (activeTabUpdate)="onTabClickQuote($event)"
          small="false" menu-width="fluid" tooltip-message="Secondary Options" active-key="">
        </bh-button-tabs>
        </div>
          <div class="search-layout m-top" >
            <input type="text"
            class="form-control"
            placeholder='{{ "savedCart.searchPlaceholder" | cxTranslate }}'
            name="search"
            [(ngModel)]="searchText"
            #search
            (keyup)="keyUp(search.value, $event)"
            >
            <span><i class="material-icons search-icon" (click)="modelChange(search.value)">search</i></span>
          </div>   
          <div class="sort-layout">
            <label>{{ "savedCart.sortBy" | cxTranslate }}</label>
            <div>
              <form [formGroup]="savedCartForm">
                <ng-select
                  formControlName="sortBy"
                  name="sortBy"
                  [(ngModel)]="sortBy"
                  (change)="loadQuoteCartData()"
                  [searchable]="false"
                  [clearable]="false"
                  placeholder='{{ "savedCart.selectPlaceholder" | cxTranslate }}'
                >
                  <ng-option *ngFor="let option of sortOptions" value="{{ option.value }}">
                    {{ option.label }}
                  </ng-option>
                </ng-select>
              </form>
            </div>
          </div> 
        </div>
          <div class="clear-filter">
            <div class="left-content filter-txt" *ngIf="searchFilter">
              {{ "quoteTracking.search" | cxTranslate }}{{this.searchText}}
              <i class="material-icons" (click)="clearSearchFilter()">close</i>
            </div>
          </div>
    <div
      *ngIf="dataSource && dataSource.length > 0"
      class="saved-cart-container mb-4"
    >
      <ng-container *ngIf="!displayLoader else loading">
        <ng-container *ngIf="quoteSharedCart == 'false'">
          <bh-tabular-list  id="quote-my-carts-table" refresh="false" [attr.header]="getQuoteHeader()" [attr.schema]="getQuoteSchema()"
            (bhEventChange)="changes($event)" (bhEventAppended)="changes($event)" [attr.payload]="getQuotePayload()" noDataAvailable="No data available"
            [attr.option]="getQuoteOptions()" ></bh-tabular-list>
        </ng-container>
        <ng-container *ngIf="quoteSharedCart == 'true'">
          <bh-tabular-list  id="quote-shared-carts-table" refresh="false" [attr.header]="getQuoteSharedHeader()" [attr.schema]="getQuoteSharedSchema()"
            (bhEventChange)="changes($event)" (bhEventAppended)="changes($event)" [attr.payload]="getQuoteSharedPayload()" noDataAvailable="No data available"
            [attr.option]="getQuoteSharedOptions()" ></bh-tabular-list>
        </ng-container>
      </ng-container>
    </div> 
    <div *ngIf=" isSaveCartEmpty && dataSource.length == 0"  class="empty-cart-page">
      <div class="container">
        <div class="empty-img"></div>
          <h1>{{ "savedCart.noCardSaved" | cxTranslate }}</h1>
          <span>{{ "savedCart.saveCardSuggestion" | cxTranslate }}</span>
          <p>{{ "savedCart.saveExistingCart" | cxTranslate }}</p>
        </div>
    </div>

    <ng-template #loading>
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    </ng-template>
    
  </mat-tab>
</mat-tab-group>
</div>
</div>

